<template>
	<div class="animated fadeIn">
		<b-card>
			<b-card-header>
				<i class="icon-menu mr-1"></i>API使用紀錄
			</b-card-header>
		  <b-card-body>
			<v-server-table :columns="columns" :data="data" :options="options" :theme="theme" ref="dataTable" id="dataTable">
				<a slot="location" slot-scope="props">{{props.row.geo_location ? props.row.geo_location : props.row.lastip}}</a>
				<a slot="user_id" slot-scope="props">{{props.row.User.firstname}}</a>
				<a slot="start_at" slot-scope="props">{{props.row.start_at|momentDis}}</a>
				<a slot="elisped" slot-scope="props">{{props.row.elisped+'ms'}}</a>

				<div slot="child_row" slot-scope="props">
					<blockquote>
						<ul>
							<li><b>CALLBACK:</b> {{props.row.callback}}</li>
							<li><b>TOKEN:</b> {{props.row.token}}</li>
							<li><b>METHOD:</b> {{props.row.method}}</li>
							<li><b>BODY:</b> {{props.row.body}}</li>
							<li><b>QUERY:</b> {{props.row.query}}</li>
							<li><b>PARAMS:</b> {{props.row.params}}</li>
							<li><b>PROTOCOL:</b> {{props.row.protocol}}</li>
						</ul>
					</blockquote>
				</div>
			</v-server-table>
		  </b-card-body>
		</b-card>
		
	</div>
</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import { required, minLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import { setupCalendar, DatePicker } from 'v-calendar'
import vSelect from 'vue-select'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import select2 from 'select2'
import _ from 'lodash'

import 'v-calendar/lib/v-calendar.min.css'

const encrypt    = config.encrypt;
const decrypt    = config.decrypt;
const admin_root = config.admin_root;

const clean_form = {
	firstname:  '',
	lastname:   '',
	company_id: '',
	role_id:    '',
	contact:    '',
	email:      '',
	phone:      '',
	handphone:  '',
	username:   '',
	secret:     ''
};

let $dyn_ajax_selec2    = null;
let $company_id_select2 = null;
let $role_id_select2    = null;

Vue.use(ServerTable)

export default {
	name: 'admin_list',
	notifications,
	components: {
		ServerTable,
		Event,
		vSelect,
		'v-date-picker': DatePicker
    },
	data(){
		let app = this;
		return {
			gender_options: [
				{label:'男', value:'男'},
				{label:'女', value:'女'},
				{label:'未知', value:'未知'}
			],
			selected_row: null,
			isFindingLoading: false,
			editRowId: null,
			record: Object.assign({}, clean_form),
			showEditorModal: false,
			delRowShowModal: false,
			delRowId: 0,
			delRowMsg: '',
			columns: ['id','hostname', 'remote_address', 'original_url', 'elisped', 'start_at', 'rec_size', 'hsize', 'res_time', 'user_id'],
			data: [],
			options: {
				headings: {
					id: '序號',
					hostname: '來源網址',
					remote_address: '來源IP',
					original_url: '請求路徑',
					elisped: '消耗時間',
					start_at: '請求時間',
					rec_size: '回傳資料筆數',
					hsize: '回傳資料大小',
					res_time: '回傳時間',
					user_id: '呼叫帳號'
				},
				orderBy: {
					column: 'id',
					ascending: false
				},
				sortable: ['id', 'start_at', 'rec_size', 'original_url', 'hsize', 'res_time', 'user_id', 'hostname', 'remote_address'],
				filterable: ['id', 'start_at', 'rec_size', 'original_url', 'hsize', 'res_time', 'user_id', 'hostname', 'remote_address'],
				sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
				pagination: {
					chunk: 5,
					edge: false,
					nav: 'scroll'
				},
				perPage: 25,
				requestFunction(data) {
					
					let action = `${admin_root}/get_list/ApiTiming`;
					let params = {
					    keyset: 'mqtt',
					    token: app.$state.$get('adminuser').token
					};

					let ccff = this.$state.$get('ccff');
					if(ccff){
						params['ccff'] = ccff;
					}

					for(let col in data){
						params[col] = data[col];
					}

					return app.$jsonp(action, params);//return the Promise
				}//eo requestFunction
			},
			useVuex: false,
	        theme: 'bootstrap4',
	        template: 'default'
		};//eo return
	},//eo data
	methods: {

		editRow(row_id, row) {
			// console.info('edit row_id:', row_id);
			this.selected_row = row;
			this.openEditor(row_id);
			
			this.record = Object.assign({}, this.selected_row);
		},//eo editRow

		delRow(row_id, row_name) {
			// console.info('del row_id:', row_id);

			this.delRowShowModal = row_id ? true : false;
			this.delRowId        = row_id;
			this.delRowMsg       = `您確定要刪除${row_name}嗎？`;
		},//eo delRow

		submitDelRow(row_id) {
			
			let app    = this;
			let action = `${admin_root}/update_user`;
			let params = {
			    keyset: 'mqtt',
			    token:  app.$state.$get('adminuser').token,
			    record: encodeURIComponent(encrypt(JSON.stringify({
			    	id: row_id,
			    	field: 'valid',
			    	value: 0,
			    	value_type: 'int'
			    })))
			};
			
			app.$jsonp(action, params).then((result) => {

				// console.info('result:', result);

				if(result.success){
					app.showSuccess({
						title: '資料更新成功',
						message: result.message
					});

					app.$refs['dataTable'].refresh();
				} else {
					app.showError({
						title: '資料更新失敗',
						message: result.message
					});
				}

			}).catch((error) => {
        		console.info('update_device error:', error);
      		});
		},

		testRow(row_id) {
			console.info('test row_id:', row_id);
			this.showWarn({
				message: '開發中',
				title: '功能暫停'
			});
		},//eo testRow

		chkState(val) {
	      const field = this.$v.record[val];
	      return !field.$dirty || !field.$invalid;
    	},

    	openEditor(row_id){
    		this.editRowId       = row_id;
    		this.showEditorModal = true;
    		this.$v.$reset();

    		let page_limit = 10;
    		let app        = this;

    		//workaround for select2 to be able to use search input
    		jQuery('div.modal-content').removeAttr('tabindex');

    		$company_id_select2 = jQuery('#device-company-id');
    		$role_id_select2    = jQuery('#device-role-id');

    		let ccff = this.$state.$get('ccff');
    		if(ccff && ccff !== 'N/A'){
    			ccff = config.decrypt(ccff, config.ffkey, config.ffiv);
    			$company_id_select2.parents('div.input-group').hide();
    			app.record.company_id = ccff;
    			app.ccff              = ccff;
    		}

    		if($company_id_select2.length){
				//init select2
				$company_id_select2.select2({
					width: 'copy',
			        dropdownAutoWidth: true,
					placeholder: '所屬公司...',
					allowClear: true,
					ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
			            url: `${admin_root}/get_option_list/Company`,
			            dataType: 'jsonp',
			            quietMillis: 800 ,
			            data: function (params) {

			                let preselected_id = jQuery(this).val();
			                
			                return {
			                    preselected_id: preselected_id,
			                    query:          params.term, // search term
			                    page_limit:     page_limit,
			                    page:           params.page || 1,
			                    token:          app.$state.$get('adminuser').token
			                };
			            },
			            results: function (data, page) {
			                var more = (page * page_limit) < data.total;
			                return {results: data.results, more: more};

			            }
			        },//eo ajax
				}).on('change', (event) => {
					app.record.company_id = $company_id_select2.select2('val');
				});
			}//eo $company_id_select2 init

			if($role_id_select2.length){
				//init select2
				$role_id_select2.select2({
					width: 'copy',
			        dropdownAutoWidth: true,
					placeholder: '所屬角色...',
					allowClear: true,
					ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
			            url: `${admin_root}/get_option_list/Role`,
			            dataType: 'jsonp',
			            quietMillis: 800 ,
			            data: function (params) {

			                let preselected_id = jQuery(this).val();
			                
			                return {
			                    preselected_id: preselected_id,
			                    query:          params.term, // search term
			                    page_limit:     page_limit,
			                    page:           params.page || 1,
			                    token:          app.$state.$get('adminuser').token
			                };
			            },
			            results: function (data, page) {
			                var more = (page * page_limit) < data.total;
			                return {results: data.results, more: more};

			            }
			        },//eo ajax
				}).on('change', (event) => {
					app.record.role_id = $role_id_select2.select2('val');
				});
			}//eo $role_id_select2 init

			//workaround for Bootstrap4
			if($company_id_select2.data('select2')){
				$company_id_select2.data('select2').$container.addClass("form-control");
			}
			if($role_id_select2.data('select2')){
				$role_id_select2.data('select2').$container.addClass("form-control");
			}

			if(row_id && app.selected_row){

				let $option1 = jQuery('<option selected>讀取中...</option>').val(app.selected_row.company_id);
				let $option2 = jQuery('<option selected>讀取中...</option>').val(app.selected_row.role_id);

				$company_id_select2.val(app.selected_row.company_id).trigger('change');
				$role_id_select2.val(app.selected_row.role_id).trigger('change');
				
				app.$jsonp(`${admin_root}/get_option_list/Company`, {
					token: app.$state.$get('adminuser').token,
					id: app.selected_row.company_id
				}).then((result) => {
					if(result.results.length){
						let rec = result.results.pop();
						$option1.text(rec.text).val(rec.id);
						$option1.removeData();

						$company_id_select2.html('');

						$company_id_select2.append($option1);

						$company_id_select2.trigger({
						    type: 'select2:select',
						    params: {
						      data: rec
						    }
						});

						$company_id_select2.val(rec.id).trigger('change');
					} else {
						// $option.revmove();
						$company_id_select2.val(null);
						app.showError({
							message: '無法讀取公司資料，請重新指定'
						});
					}
				});

				app.$jsonp(`${admin_root}/get_option_list/Role`, {
					token: app.$state.$get('adminuser').token,
					id: app.selected_row.role_id
				}).then((result) => {
					if(result.results.length){
						let rec = result.results.pop();
						$option2.text(rec.text).val(rec.id);
						$option2.removeData();

						$role_id_select2.html('');

						$role_id_select2.append($option2);

						$role_id_select2.trigger({
						    type: 'select2:select',
						    params: {
						      data: rec
						    }
						});

						$role_id_select2.val(rec.id).trigger('change');
					} else {
						// $option.revmove();
						$role_id_select2.val(null);
						app.showError({
							message: '無法讀取角色資料，請重新指定'
						});
					}
				});
			}

    		if(!row_id){
				app.record       = Object.assign({}, clean_form);
				app.selected_row = null;
				app.row_id       = null;
			}
    	},

    	submitRecord() {

    		let app    = this;
    		let row_id = app.editRowId;

    		this.$v.$touch();

		    if (this.$v.$invalid) {
		        this.showError({message:'請輸入必填欄位', title:'資料錯誤'});
		        this.showEditorModal = true;
		        return false;
		    }

		    let to_save = this.record;

		    if(row_id){
		    	to_save['id'] = row_id;
		    }

		    let selected_company = $company_id_select2.select2('data').pop();

		    // console.info('selected_company:', selected_company);return;

		    if(selected_company){
		    	to_save['company'] = selected_company.text;
		    }

		    if(app.ccff){
		    	to_save['company_id'] = app.ccff;
		    	to_save['company']    = this.$state.$get('company_name');
		    }

		    // console.info('before send: ', to_save);

		    to_save = encodeURIComponent(encrypt(JSON.stringify(to_save)));

		    let action = `${admin_root}/save_user`;
		    let params = {
		    	keyset: 'mqtt',
		    	token:  this.$state.$get('adminuser').token,
		    	record: to_save
		    };

		    this.$jsonp(action, params).then((result) => {
		    	if(result.success){
		    		app.showSuccess({
		    			title: '成功',
		    			message: '資料成功儲存'
		    		});
		    		app.$refs['dataTable'].refresh();
		    		app.record = Object.assign({}, clean_form);
		    		app.$v.$reset();
		    	} else {
		    		let cat_msg = '';

		    		if(result.error && result.error.errors && result.error.errors.length){
		    			result.error.errors.forEach((err) => {
		    				cat_msg += "\n" + `[${err.type}]:` +err.message + "\n";
		    			});
		    		}

		    		app.showError({
		    			title: '錯誤',
		    			message: '無法儲存資料，請稍後再試。'+cat_msg,
		    			timeout: 10000
		    		});
		    		app.$refs['dataTable'].refresh();
		    	}
		    });
    	},
	},//eo methods
	validations: {
		record: {
			firstname: {
			  required,
			  minLength: minLength(1)
			},
			lastname: {
			  required,
			  minLength: minLength(1)
			},
			company_id: {
			  required: false,
			  // integer,
			  // minLength: minLength(1)
			},
			role_id: {
			  required,
			  integer,
			  minLength: minLength(1)
			},
			contact: {
			  required,
			  minLength: minLength(1)
			},
			email: {
			  required,
			  email
			},
			username: {
			  required,
			  minLength: minLength(5)
			},
			secret: {
			  required,
			  minLength: minLength(5)
			}
		}
	},//eo validations
	
};
</script>
<style lang="scss">
.card-body{padding:0;}
.add-btn{}
.multiselect__input{width:100%;border:none;}

#dataTable {
	width: 95%;
	margin: 0 auto;
	margin-top: 0.5rem;
	font-size: 0.75rem;

	.VuePagination {
	  text-align: center;
	  justify-content: center;
	}

	.vue-title {
	  text-align: center ;
	  margin-bottom: 10px;
	}

	.VueTables__search-field {
	  display: flex;
	}
	.VueTables__search-field input {
	  margin-left: 0.25rem;
	}

	.VueTables__limit-field {
	  display: flex;
	}

	.VueTables__limit-field select {
	  margin-left: 0.25rem !important;
	}

	.VueTables__table th {
	  text-align: center;
	}

	.VueTables__child-row-toggler {
	  width: 16px;
	  height: 16px;
	  line-height: 16px;
	  display: block;
	  margin: auto;
	  text-align: center;
	}

	.VueTables__child-row-toggler--closed::before {
	  content: "+";
	}

	.VueTables__child-row-toggler--open::before {
	  content: "-";
	}

	.VueTables__sortable {
		padding: 0.25rem;
	}
}
</style>
